import '../../admin-shared.css'

import { useNavigate, useParams } from 'react-router-dom'

import { Input, PageHeader, Spinner } from '../../../../Components'
import { useCQuery } from '../../../../Services'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { AdminEditorActions } from '../../Components/AdminTableActions'
import { saveTraveller, useTraveller } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language]

const fields = {
  pid: { label: t.admPID },
  email: { label: t.admEmail },
  phone: { label: t.admTelefono },
  name: { label: t.admNome },
  surname: { label: t.admCognome }
}

export function TravellerEditor() {
  const { travellerId } = useParams()
  const navigate = useNavigate()
  const [traveller, setTraveller, isSuccess] = useTraveller(travellerId)
  const { id = '', clientId } = traveller || {}
  const { data: clients = [] } = useCQuery(['clients'])

  const save = async () => {
    const res = await saveTraveller(traveller)
    res?.id && navigate('/admin/travellers/' + res?.id?.toString())
    return res
  }

  if (!isSuccess || !traveller) return <Spinner />

  const isNew = id === 'new'

  return (
    <div className="admin-page--medium">
      <PageHeader
        title={isNew ? t.admCreaViaggiatore : t.admModificaViaggiatore}
        actions={
          <AdminEditorActions
            onBack={() => navigate('/admin/travellers/list')}
            onSave={save}
            backLabel={t.tornaIndietro}
            saveLabel={t.salva}
          />
        }
      />

      <div className="nsec">
        <div className="nsec__head">
          <div className="nsec__ico">
            <i className="pi pi-user" style={{ fontSize: 16 }} />
          </div>
          <h3 className="nsec__title">{t.admAnagraficaViaggiatore}</h3>
        </div>
        <div className="nsec__body">
          <div className="nrow">
            {Object.keys(fields).map((key) => (
              <div key={key} className="nfield" style={{ gridColumn: 'span 4' }}>
                <label>{fields[key]?.label}</label>
                <Input
                  value={traveller[key]}
                  onChange={({ [key]: value }) => setTraveller(key, value)}
                  id={key}
                  style={{ width: '100%' }}
                />
              </div>
            ))}
            <div className="nfield" style={{ gridColumn: 'span 4' }}>
              <label>{t.client}</label>
              <Input
                value={clientId}
                dropdown
                options={clients.map(({ id: cid, name }) => ({ value: cid, label: name }))}
                onChange={({ clientId: value }) => setTraveller('clientId', value)}
                id="clientId"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
